import Footer from '@/components/footer'
import Header from '@/components/header'

export const TermsAndConditions = () => {
	return (
		<div className="bg-landing-page bg-cover bg-no-repeat">
			<div className="max-w-[150rem] mx-auto">
				<Header currentPage="letter" />
				<div className="mt-5 lg:mt-[90px] flex items-center flex-col gap-3 lg:gap-2">
					<h1 className="text-secondary text-center text-xl lg:text-5xl font-extrabold">
						Allgemeine Geschäftsbedingungen
					</h1>
					<p className="text-secondary text-center text-sm lg:text-xl font-medium">
						Regeln und Bedingungen für die Nutzung
					</p>
				</div>
				<div className="mt-8 lg:px-[72px] px-5 lg:mt-[86px] flex flex-col gap-8">
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							Allgemeine Geschäftsbedingungen (AGB)
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Diese Allgemeinen Geschäftsbedingungen (nachfolgend &quot;AGB&quot;) regeln das
								Vertragsverhältnis zwischen der Mirzoyan GbR, handelnd unter der
								Geschäftsbezeichnung &quot;minmini&quot; (nachfolgend &quot;minmini&quot; oder
								&quot;Vermieter&quot;) und den Mietern (nachfolgend &quot;Mieter&quot; oder
								&quot;Sie&quot;) in Bezug auf die zeitlich befristete Vermietung von Regalflächen
								und die Vermittlung des Verkaufs von Artikeln durch minmini.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">1 . Geltungsbereich</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Diese AGB gelten für alle Vertragsverhältnisse, die zwischen minmini und dem Mieter
								im Zusammenhang mit der Anmietung von Verkaufsflächen und der Nutzung damit
								verbundener Dienstleistungen zustande kommen. Sie gelten sowohl für Onlinebuchungen
								über die Website als auch für Buchungen, die unmittelbar vor Ort im Laden erfolgen.
								Mit der Buchung eines Regals und der Nutzung der Leistungen von minmini erklärt sich
								der Mieter mit diesen AGB einverstanden. Die AGB gelten auch für alle zukünftigen
								Geschäftsbeziehungen, auch wenn sie nicht nochmals ausdrücklich vereinbart werden.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">2 . Vertragsschluss</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Der Mietvertrag kommt durch Buchung über die Website oder durch Abschluss im
								Ladengeschäft sowie durch ausdrückliche Annahme durch minmini zustande. Ein Anspruch
								auf Abschluss eines Mietvertrags besteht nicht. minmini behält sich das Recht vor,
								Buchungen ohne Angabe von Gründen abzulehnen. minmini kann auch bereits
								abgeschlossene Buchungen ohne Angabe von Gründen stornieren. Falls Miete gezahlt
								wurde, erfolgt eine anteilige Rückerstattung - bei der 45 %-Variante dagegen nur
								eine reguläre Abrechnung ohne Rückzahlung. Der Mietvertrag berechtigt den Mieter zur
								Nutzung der vereinbarten Verkaufsfläche für den Verkauf von Kinderartikeln für die
								vereinbarte Mietdauer. minmini tritt gegenüber Kunden als Vermittler auf und führt
								den Verkauf der Artikel im Namen und auf Rechnung des Mieters aus.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							3 . Nutzung der Verkaufsfläche
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Der Mieter verpflichtet sich, die Verkaufsfläche pfleglich zu behandeln, sauber und
								frei von Abfall zu halten und weder elektrische Geräte anzuschließen noch bauliche
								Veränderungen vorzunehmen. Die Nutzung darf nicht zu Beeinträchtigungen für das
								Mietobjekt, das Gebäude oder Dritte führen. Beschädigungen oder Verunreinigungen
								sind minmini bei Übernahme unverzüglich zu melden. Erfolgt keine Meldung, gilt die
								Mietsache als mangelfrei übernommen.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							4 . Einschränkungen und verbotene Gegenstände
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Nicht erlaubt ist die Auslage oder der Verkauf von gefälschten Artikeln,
								verderblichen Waren, Lebensmitteln, brennbaren oder gefährlichen Stoffen, lebenden
								oder lebensfähigen Organismen, Flüssigkeiten, Gasen, Farben oder sonstigen
								Gegenständen, die Emissionen verursachen oder Rechte Dritter verletzen. Außerhalb
								der Mietfläche gelagerte Gegenstände können kostenpflichtig entfernt werden.
								Störendes Verhalten ist zu unterlassen.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							5 . Sonderregelung für die Kommissionsvariante mit 45 % Provision
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Die Kommissionsvariante mit einer Verkaufsprovision von 45 % kann pro Haushalt
								maximal dreimal pro Kalenderjahr in Anspruch genommen werden. Bei dieser Variante
								ist nur ein Regal pro Mietzeitraum zulässig. Parallele oder mehrfache Buchungen
								durch denselben Haushalt sind untersagt. Versuche, die Begrenzung durch Buchungen im
								Namen Dritter zu umgehen, berechtigen minmini zur Stornierung und ggf. zum Ausspruch
								eines Hausverbots.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">6 . Pflichten des Mieters</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Der Mieter ist verpflichtet, bei Vertragsschluss alle erforderlichen Angaben (Name,
								Adresse, Kontaktinformationen, Bankverbindung) vollständig und korrekt zu
								hinterlegen. Unterbleibt dies, haftet der Mieter für etwaige Zustellfehler oder
								fehlgeschlagene Auszahlungen.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							7 . Miet- und Verkaufserlöse
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Die Mietpreise richten sich nach der Mietdauer und sind auf der Website einsehbar.
								Nach Ablauf der Mietzeit erfolgt eine Abrechnung des Verkaufserlöses abzüglich der
								vereinbarten Verkaufsprovision von 20 % bzw. 45 % (oder individuell vereinbart). Die
								Auszahlung erfolgt auf die angegebene Bankverbindung. Das Mietverhältnis gilt als
								beendet, wenn sämtliche Artikel entfernt und aus dem Geschäft abgeholt wurden. Erst
								dann beginnt die Frist zur Erstellung der Endabrechnung, welche innerhalb von 7
								Werktagen erfolgt. minmini behält sich das Recht vor, offene Forderungen wie Lager-
								oder Mahngebühren vor Auszahlung zu verrechnen.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							8 . Stornierungen und Vertragsbeendigung
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Die Stornierung eines Regals ist bis 14 Tage vor Mietbeginn kostenlos möglich. Bei
								einer Stornierung bis sieben Tage vor Beginn werden 50 % der Mietkosten erstattet.
								Bei einer Stornierung weniger als sieben Tage vor Mietbeginn entfällt der Anspruch
								auf Rückerstattung. Bei der 45 %-Variante wird bei einer Stornierung bis sieben Tage
								vor Mietbeginn eine pauschale Ausfallgebühr in Höhe von 15 € erhoben. MinMini behält
								sich vor, Buchungen jederzeit aus wichtigem Grund zu stornieren und das
								Mietverhältnis mit sofortiger Wirkung zu beenden.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							9 . Ein- und Ausräumen der Regale
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Artikel dürfen frühestens einen Werktag vor Mietbeginn, eine Stunde vor
								Ladenschluss, eingeräumt werden. Das Regal muss bis Ladenschluss des ersten Miettags
								bestückt sein. Erfolgt dies nicht bis zum Beginn des dritten Miettags, kann minmini
								die Buchung stornieren. In diesem Fall fällt eine Ausfallgebühr von 15,00 EUR an.
								Die Miete ist über die gesamte vereinbarte Dauer zu nutzen. Ein verspätetes
								Einräumen oder ein vorzeitiges Abholen - also vor Ablauf der Mietzeit - stellt keine
								ordnungsgemäße Inanspruchnahme dar. minmini behält sich in solchen Fällen das Recht
								vor, eine angemessene Ausfallgebühr zu erheben.
							</li>
							<li>
								Am letzten Miettag ist das Regal bis eine Stunde vor Ladenschluss zu räumen. Wird
								dies versäumt oder das Regal in unzumutbarem Zustand hinterlassen, wird eine
								Bearbeitungsgebühr von 15,00 EUR erhoben. Zusätzlich wird für jeden weiteren Tag, an
								dem Artikel nicht abgeholt wurden, eine Lagergebühr von 5,00 EUR pro Tag fällig.
							</li>
							<li>
								Sollten einzelne Artikel oder Bestandteile bei Mietende nicht abgeholt werden und
								daher im Geschäft verbleiben, werden diese für einen Zeitraum von 14 Kalendertagen
								aufbewahrt. Erfolgt innerhalb dieser Frist keine Abholung, ist der Betreiber
								berechtigt, die betreffenden Artikel ohne weitere Ankündigung zu spenden. Ein
								Anspruch auf Herausgabe, Auszahlung oder Wertersatz besteht nach Ablauf der Frist
								nicht.
							</li>
							<li>
								Dies gilt ebenfalls für Artikel oder Einzelteile, die von minmini keinem Verkäufer
								eindeutig zugeordnet werden können und die nicht innerhalb der vorgenannten Frist
								als vermisst gemeldet werden. Auch diese dürfen nach Ablauf der Frist gespendet
								werden.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							10 . Ein- und Ausräumservice und Lagerung
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Optional kann ein Ein- und Ausräumservice für 15,00 EUR gebucht werden. Die Artikel
								müssen dann 72 bis spätestens 48 Stunden vor Mietbeginn im Laden abgegeben werden.
								Nach Mietende werden die verbliebenen Artikel von minmini aus dem Regal entfernt und
								zwischengelagert. Der Mieter erhält per E-Mail eine Benachrichtigung darüber, dass
								die Artikel abholbereit sind. Die Artikel sind anschließend innerhalb von 72 Stunden
								abzuholen. Wird diese Frist überschritten, fällt eine Lagergebühr in Höhe von 5,00
								EUR pro Tag an.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							11 . Artikelplatzierung und Sicherheit
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Es dürfen ausschließlich Artikel im gebuchten Regal ausgestellt werden. Das
								Platzieren von Waren außerhalb des gemieteten Regals - z. B. auf Nachbarregalen,
								Böden, Ablagen oder zentralen Flächen - ist nur nach ausdrücklicher schriftlicher
								Genehmigung durch minmini gestattet. Artikel, die ohne Genehmigung außerhalb des
								Regals abgelegt werden, können jederzeit entfernt und ggf. kostenpflichtig
								eingelagert oder entsorgt werden.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">12 . Regalzuordnung</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Ein Anspruch auf ein bestimmtes Regal besteht nicht. minmini ist berechtigt, dem
								Mieter aus organisatorischen Gründen ein anderes Regal zuzuweisen.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">13 . Haftung</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								minmini übernimmt keine Haftung für Diebstahl, Verlust, Beschädigung,
								Elementarschäden oder Funktionsmängel der eingebrachten Artikel – es sei denn, diese
								Schäden beruhen auf Vorsatz oder grober Fahrlässigkeit seitens minmini. Bei leichter
								Fahrlässigkeit haftet minmini ausschließlich bei der Verletzung wesentlicher
								Vertragspflichten (sogenannter Kardinalpflichten) und nur für den typischen,
								vorhersehbaren Schaden. Die Haftung für Schäden an Leben, Körper oder Gesundheit
								bleibt hiervon unberührt.
							</li>
							<br />
							<li>
								Da es sich bei den Verkaufsräumen um ein familienorientiertes Geschäft mit
								regelmäßigem Besuch durch Kinder handelt, weist minmini ausdrücklich darauf hin,
								dass Artikel während der Mietdauer auch durch spielende oder unbeaufsichtigte Kinder
								beschädigt werden können. Solche Beschädigungen stellen kein Verschulden seitens
								minmini dar und begründen keinen Haftungsanspruch gegenüber dem Vermieter.
							</li>
							<br />
							<li>
								Zudem ist es Teil des normalen Geschäftsablaufs, dass Kundinnen und Kunden Artikel
								aus einem Regal entnehmen und anschließend versehentlich in ein anderes zurücklegen.
								Da eine ständige Kontrolle aller Regale durch das Personal nicht möglich ist, kann
								minmini hierfür keine Haftung übernehmen. Es wird nach Möglichkeit darauf geachtet,
								solche Fälle zu vermeiden, jedoch kann eine vollständige Ordnung der Artikel nicht
								garantiert werden.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							14 . Rückgabe und Umtausch
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Ein Rückgabe- oder Umtauschrecht für gekaufte Artikel besteht nicht, da der Verkauf
								im Namen privater Dritter erfolgt. Die gesetzlichen Regelungen zum
								Verbrauchsgüterrecht bleiben unberührt.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">15 . Mängelanzeige</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Treten während der Mietzeit Mängel auf, ist minmini unverzüglich schriftlich zu
								informieren. Unterbleibt dies, kann eine Haftung ausgeschlossen werden, wenn der
								Schaden durch frühere Anzeige vermeidbar gewesen wäre.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">16 . Datenschutz</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Die Erhebung und Verarbeitung personenbezogener Daten erfolgt ausschließlich zum
								Zwecke der Vertragsdurchführung. Es gilt die Datenschutzerklärung auf der Website
								von minmini.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">17 . Schriftform</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Ergänzende Vereinbarungen bedürfen der Schriftform. Mündliche Nebenabreden sind
								unwirksam.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							18 . Salvatorische Klausel
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Sollte eine Bestimmung dieser AGB unwirksam oder nicht durchsetzbar sein, bleibt die
								Wirksamkeit der übrigen Bestimmungen unberührt. An deren Stelle tritt die
								gesetzliche Regelung, die dem wirtschaftlichen Zweck am nächsten kommt.
							</li>
						</ol>
					</div>
					<div className="flex flex-col gap-2">
						<h2 className="text-secondary lg:text-2xl font-extrabold">
							19 . Anwendbares Recht und Gerichtsstand
						</h2>
						<ol className="leading-[29px] lg:leading-[42px] text-muted-foreground text-xs lg:text-xl font-medium list-outside">
							<li>
								Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Ist der Mieter Kaufmann
								oder eine juristische Person des öffentlichen Rechts, ist ausschließlicher
								Gerichtsstand der Sitz der Mirzoyan GbR.
							</li>
						</ol>
					</div>
				</div>
				<div className="mt-16 lg:mt-[141px] bg-[#E6E6E6] w-full h-px" />
				<Footer />
			</div>
		</div>
	)
}
